<div awairForm>
  <ng-container formHeader>
    <h2 awairFormTitle>Select an Organization</h2>
    <h3 awairFormSubTitle>Select the organization you'd like to explore.</h3>
  </ng-container>

  <ng-container formBody>
    <!-- List field -->
    <ul class="aw-lg-list" awairScrollPrevent>

      <!-- Loading Organization List -->
      <ng-container *ngIf="isLoading && !selectedOrganization; else organizations">
        <li class="aw-create-btn loading" style="cursor: initial;">
          Loading Organization List...
        </li>
      </ng-container>
      <!-- /.Loading Organization List -->

      <ng-template #organizations>
        <!-- Activated Organization List -->
        <li class="aw-lg-list-item"
            *ngFor="let activatedOrganization of activatedOrganizations; let i = index"
            [ngClass]="{'aw-lg-list-item--selected': (activatedOrganization?.id === selectedOrganization?.id)}"
            (click)="onSelectOrganization(activatedOrganization)"
            (dblclick)="onEnterOrganization(selectedOrganization)">
          <div class="float-left flex-col" style="height: 40px">
            <div class="aw-lg-list-item__main">{{activatedOrganization.name}}</div>
            <div class="aw-lg-list-item__sub">{{activatedOrganization.numberOfDevices}} Devices</div>
          </div>
          <div class="float-right flex-row" style="height: 40px">
            <div class="aw-lg-list-item__tail">{{activatedOrganization.role | namize}}</div>
            <!-- More -->
            <!--<img class="more" src="assets/images/more.png" (click)="showMore($event, moreToggle)">
            <ul class="dropdown-organization-list" [style.display]="moreDropdownToggle" #moreToggle>
              <li *ngIf="activatedOrgDetail.role === 'owner'" class="drop-item">Edit name</li>
              <li *ngIf="activatedOrgDetail.role === 'owner'" class="drop-item">Delete</li>
              <li *ngIf="activatedOrgDetail.role !== 'owner'" class="drop-item">Leave</li>
            </ul>-->
            <!-- /.More -->
          </div>
        </li>
        <!-- /.Activated Organization List -->

        <!-- Deactivated Organization List -->
        <li class="aw-lg-list-item--blur"
            *ngFor="let deactivatedOrganization of deactivatedOrganizations; let i = index"
            [style.margin-bottom]="i === (deactivatedOrganizations.length - 1) ? '2px' : '8px'">
          <div class="float-left flex-col" style="height: 40px">
            <div class="aw-lg-list-item__main--blur">{{deactivatedOrganization.name}}</div>
            <div class="aw-lg-list-item__sub">Deactivated</div>
          </div>
        </li>
        <!-- /.Deactivated Organization List -->

        <!-- Pending Organization List -->
        <li class="aw-lg-list-item--blur"
            *ngFor="let pendingOrganization of pendingOrganizations; let i = index"
            [style.margin-bottom]="i === (pendingOrganizations.length - 1) ? '2px' : '8px'">
          <div class="float-left flex-col" style="height: 40px">
            <div class="aw-lg-list-item__main--blur">{{pendingOrganization.name}}</div>
            <div class="aw-lg-list-item__sub">Pending</div>
          </div>
        </li>
        <!-- /.Pending Organization List -->
      </ng-template>

    </ul>
    <!-- /.List field -->

    <!-- Create New Organization -->
    <button class="aw-create-btn"
            [disabled]="isLoading"
            (click)="onCreateOrganization()">
      + Create a New Organization
    </button>
    <!-- /.Create New Organization -->

  </ng-container>

  <ng-container formFooter>
    <!-- Invite button -->
    <button type="submit"
            *ngIf="!isDialog"
            class="aw-btn aw-btn-blue"
            style="width: 100%"
            [disabled]="!selectedOrganization || isLoading"
            (click)="onEnterOrganization(selectedOrganization)">
      Next
    </button>

    <div class="btn-group" *ngIf="isDialog">
      <button class="aw-btn aw-btn-gray"
              (click)="onCancel()">
        Cancel
      </button>
      <button class="aw-btn aw-btn-blue"
              [disabled]="!selectedOrganization || isLoading"
              (click)="onEnterOrganization(selectedOrganization)">
        Next
      </button>
    </div>
    <!-- /.Invite button -->
  </ng-container>

</div>
